import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Portfolio() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/portfolio"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Our Works</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Our Works</li>
      </ul>
    </div>
  </div>
  <section id="integrations" className="py-100 integrations-2 integrations-section division">
    <div className="container">
      <div className="posts-wrapper">
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3">
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#e2ddd2'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/850e5901-6623-491a-7a8a-94225bbf6800/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Atelier Clinic</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#b8ddd0'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/4d9d7404-6165-4847-3e4a-9e33b9e64200/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>ZEE Development</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#f7e8d5'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/792d99c5-e596-43a2-9a35-685825cf8900/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Afghan Turk Palace Restaurant</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#fde0ce'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/df37c026-eb51-4736-425d-cc11dc42f000/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div> IGraphics</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#c2ecf2'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/8be4119a-6eb3-4877-ca7d-7c44358e3f00/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Alsoum Real Estate</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#d0eee7'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/885715cb-8785-49b9-fd55-ff9832dad100/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Occult Clinic</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#f4dbda'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/2fb32d00-2a54-4459-4649-ee023037d700/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Look in Tyres</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#cdeee1'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/0bdf35bc-17bb-401c-c52d-d5b15bc2c200/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Al Manal Centre</p></li>
                  </ul>
                  <div>Luxe Home Dubai</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#e2ddd2'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/060b8a16-86f8-4e05-5044-40a5bc08c000/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Loft &amp; Mansion</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#d0def0'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/2f6412fc-2f9a-4dd4-4a39-da3beb709300/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Compra Casa en Dubai</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#d2ecf1'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/5360a2d1-dc66-43b3-38e6-c972b813b100/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>Numero Pearls</div>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a href="#">
              <div className="our-work-box">
                <div className="work-image-bx" style={{backgroundColor: '#d3d7eb'}}>
                  <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/92f3b1a7-d387-40a5-b713-872321c00d00/w=1920,sharpen=1" />
                </div>
                <div className="works-txt">
                  <ul className="post-meta-list clearfix">
                    <li><p className="fs-15">Web Deigning</p></li>
                    <li><p className="fs-15">Social Media Marketing</p></li>
                  </ul>
                  <div>A LAND</div>
                </div>
              </div>
            </a>
          </div>
        </div>  {/* End row */}
      </div>
    </div>     {/* End container */}
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default Portfolio;
